import { render } from "./ContactsList.vue?vue&type=template&id=51bd1f0a&ts=true"
import script from "./ContactsList.vue?vue&type=script&lang=ts"
export * from "./ContactsList.vue?vue&type=script&lang=ts"

import "./ContactsList.vue?vue&type=style&index=0&id=51bd1f0a&lang=css"

import exportComponent from "/Users/aleksandrvasilevic/Documents/Dev/WEB/Pets/phone-book/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__